import React from 'react';
import { createStyles, IconButton, makeStyles } from '@material-ui/core';
import { ChevronLeft } from '@material-ui/icons';
import { ChannelsPageLayoutHeaderContext } from './channelsLayoutHeaderContext';
import { useAppDispatch, useAppSelector } from '../../../hooks/useStore';
import { ChannelsListToolbar } from './ChannelsListToolbar';
import { ChannelContentToolbar } from './ChannelsContentToolbar';
import {
  togglePrimarySidebarMobile,
  toggleSecondarySidebar,
} from '../../../store/ui/actions';
import MenuLogo from '../../Navbar/MenuLogo';
import { HamburgerIcon } from '../../Icons';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 60,
      width: '-webkit-fill-available',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  }),
);

/**
 * The channels page header component is composed of 2 parts:
 * 1. Channels list toolbar: contains the page title and the create button
 * 2. Channels content toolbar: contains the channel title and the channel actions
 */
export const ChannelsPageHeader: React.FC = () => {
  const isSecondarySidebarOpen = useAppSelector(
    state => state.ui.secondarySideBar.isOpen,
  );
  const classes = useStyles({
    isSecondarySidebarOpen: Boolean(isSecondarySidebarOpen),
  });

  const {
    createButtonProps,
    activeChannelTitle,
    channelHeaderActions = [],
    setChannelHeaderMenuAnchorEl,
    channelsListToolbarHidden,
    pageTitle,
  } = React.useContext(ChannelsPageLayoutHeaderContext);

  const dispatch = useAppDispatch();

  /**
   * This function handles the menu button click event.
   * If the secondary sidebar is open, it should close it.
   * Otherwise, it should open the primary sidebar.
   * @returns
   */
  const handleMenuButtonClick = React.useCallback(() => {
    if (isSecondarySidebarOpen) {
      dispatch(
        togglePrimarySidebarMobile({
          isOpen: true,
        }),
      );
    } else {
      dispatch(
        toggleSecondarySidebar({
          isOpen: true,
        }),
      );
    }
  }, [isSecondarySidebarOpen]);

  return (
    <div className={classes.root}>
      <MenuLogo
        menuClickCallback={handleMenuButtonClick}
        Icon={isSecondarySidebarOpen ? HamburgerIcon : ChevronLeft} // when secondary sidebar is open, the menu button should be a hamburger icon, otherwise it should be a chevron left
      />
      {!channelsListToolbarHidden && (
        <ChannelsListToolbar
          pageTitle={pageTitle}
          createButtonProps={createButtonProps}
          isSecondarySidebarOpen={Boolean(isSecondarySidebarOpen)}
        />
      )}

      <ChannelContentToolbar
        activeChannelTitle={activeChannelTitle}
        channelHeaderActions={channelHeaderActions}
        setChannelHeaderMenuAnchorEl={setChannelHeaderMenuAnchorEl}
        isSecondarySidebarOpen={Boolean(isSecondarySidebarOpen)}
      />
    </div>
  );
};
